import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ROUTE_KEYS } from '@constants'

import { LoginButton, LoginTitle, LoginContentContainer } from '../components'

const { TRADITIONAL, SSO } = ROUTE_KEYS.LOGIN

const Login = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleSSO = () => {
    navigate(SSO)
  }

  const handleTraditional = () => {
    navigate(TRADITIONAL)
  }

  return (
    <LoginContentContainer>
      <LoginTitle color="gray">{t('login.title')}</LoginTitle>
      <LoginButton type="primary" size="large" onClick={handleSSO}>
        {t('login.sso')}
      </LoginButton>
      <LoginButton type="primary" size="large" onClick={handleTraditional}>
        {t('login.user_password')}
      </LoginButton>
    </LoginContentContainer>
  )
}

const LoginError = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleErrorAccept = () => {
    navigate('/login')
  }

  return (
    <LoginContentContainer>
      <LoginTitle color="gray">{t('login.error.title')}</LoginTitle>
      <LoginTitle color="gray">{t('login.error.subMessage')}</LoginTitle>
      <LoginButton type="primary" size="large" onClick={handleErrorAccept}>
        {t('login.error.accept')}
      </LoginButton>
    </LoginContentContainer>
  )
}

export { Login, LoginError }
